import { toHaveDisplayValue } from '@testing-library/jest-dom/dist/matchers';
import { makeObservable, observable, computed, action } from 'mobx';
import { erpApiurl } from '../stores/APIEndpoints';

import { apiHost } from './APIEndpoints';

const PENDING = 'pending';
const DONE = 'done';
const ERROR = 'error';

const EMPTY_MESSAGE = { status: "", help: "" };
const ERROR_MESSAGE = { status: "error", help: "Unable to fetch the Lab Summary. The Service is unavailable. Please try after sometime." };

export default class LabReceivableStore {

    state = PENDING;
    regState = PENDING;

    message = EMPTY_MESSAGE;
    receivables = [];
    totalReceivable = 0;
    totalReceived = 0;
    collectionType = '';

    rowCount = 0;

    buckets = new Set();

    constructor(props) {
        this.apiProxy = props.apiProxy;
        this.referrerId = props.referrerId;
        this.collectionType = props.collectionType;

        makeObservable(this, {
            state: observable,
            regState: observable,

            message: observable,
            receivables: observable,
            rowCount: observable,
            totalReceivable: observable,
            totalReceived: observable,

            isLoading: computed,
            isError: computed,
            isDone: computed,
            canGenerate: computed,
            due: computed,

            fetchSummary: action,
        });
    }


    get isLoading() {
        return this.state === PENDING;
    }

    get isError() {
        return this.state === ERROR;
    }

    get isDone() {
        return this.state === DONE;
    }

    get canGenerate() {
        return this.collectionType !== "unknown" && this.rowCount > 0;
    }

    get due() {
        return this.totalReceivable - this.totalReceived;
    }

    generateInvoice = async() => {
        if(this.collectionType === "unknown") {
            return;
        }
        if(this.rowCount === 0) {
            return;
        }

        this.state = PENDING;
        this.message = EMPTY_MESSAGE;

        const apiEndpoint = `${erpApiurl}api/Carbon/GenerateLabInvoice`;

        try {
            const postables = this.getPostables();

            await this.apiProxy.asyncPost(apiEndpoint, postables);
            await this.fetchSummary(this.collectionType);
            this.state = DONE;
        }
        catch (e) {
            this.state = ERROR;
            this.message = ERROR_MESSAGE
            console.log(e);
        }
    }

    getPostables = () => {
        const bucketArr = [];
        for (const entry of this.buckets.values()) {
            bucketArr.push(entry);
        }
        return { "ReferrerId": this.referrerId, "invoiceType": this.collectionType, "buckets": bucketArr};
    }


    /**
     * Send the request to the endpoint using the FetchAPI
     * 
     */
    fetchSummary = async (collectionType) => {

        const url = `${erpApiurl}api/Carbon/GetLabSideWiseSummary?ReferrerId=${this.referrerId}&collectionType="+collectionType`;

        this.state = PENDING;
        this.message = EMPTY_MESSAGE;
        this.collectionType = collectionType;

        try {
            const response = await this.apiProxy.getAsync(url);
            const data = await response.json();

            if (data.Message) {
                this.message = ERROR_MESSAGE;
                this.state = DONE;
                return;
            }
            this.receivables = data;
            
            let total = 0;
            let totalAdvance = 0;
            
            this.buckets.clear();

            data.map((labreceivable) => 
            {
                this.buckets.add(labreceivable.Bucket);
                total = total + labreceivable.Total;
                totalAdvance = totalAdvance + labreceivable.PaidAmount; 
            });

            this.rowCount = this.buckets.size;
            this.totalReceivable = total;
            this.totalReceived = totalAdvance;
            this.state = DONE;
        }
        catch (e) {
            this.state = ERROR;
            this.message = ERROR_MESSAGE;
        }
    }
}
